import React from "react";

export const Dot = () => <span style={{ margin: "0 5px" }}>&#8226;</span>;
